module.exports = __webpack_public_path__ + "img/elsa-login-pic2.9a638b42.png";